module.exports = __webpack_public_path__ + "static/media/Full_Modal_Header@3x.75d9aaa1.png";